import { render, staticRenderFns } from "./MemoTxnList.vue?vue&type=template&id=0ddd8049&scoped=true"
import script from "./MemoTxnList.vue?vue&type=script&lang=js"
export * from "./MemoTxnList.vue?vue&type=script&lang=js"
import style0 from "./MemoTxnList.vue?vue&type=style&index=0&id=0ddd8049&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddd8049",
  null
  
)

export default component.exports